/**
 * A directory display name as people say it: "First Last".
 *
 * The corporate directory stores `displayName` as "Last, First" ("Alev, Alban"). When the name
 * holds a comma it is turned around at the first one; any other name is returned as it is. The
 * full directory form stays available to callers for a tooltip.
 */
export function firstLastName(displayName: string): string {
  const name = displayName.trim()
  const comma = name.indexOf(',')
  if (comma < 0) return name
  const last = name.slice(0, comma).trim()
  const first = name.slice(comma + 1).trim()
  if (!first) return last
  if (!last) return first
  return `${first} ${last}`
}
